import React from 'react';
import './scss/SuccessPopup.scss';

function SuccessPopup({ show, onClose }) {
  if (!show) return null;

  return (
    <div className="popup-backdrop">
      <div className="popup-box">
        <h2>✅ Request sended</h2>
        <p>Your requisition was successfully received. Thanks for contact us.</p>
        <button onClick={onClose}>OK</button>
      </div>
    </div>
  );
}

export default SuccessPopup;
